

import { useTranslation } from 'react-i18next';

export function useFormatRelativeTime(dateString: string): string {
    const { t } = useTranslation();
    
    const date = new Date(dateString);
    const now = new Date();
    const diffMs = now.getTime() - date.getTime();
    const diffDays = Math.floor(diffMs / (1000 * 60 * 60 * 24));
    const diffHours = Math.floor(diffMs / (1000 * 60 * 60));
    const diffMinutes = Math.floor(diffMs / (1000 * 60));

    if (diffMinutes < 1) {
        return t('notifications.time.justNow');
    }
    if (diffMinutes < 60) {
        return t('notifications.time.minutesAgo', { count: diffMinutes });
    }
    if (diffHours < 24) {
        return t('notifications.time.hoursAgo', { count: diffHours });
    }
    if (diffDays < 7) {
        return t('notifications.time.daysAgo', { count: diffDays });
    }

    return date.toLocaleDateString();
};